"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _DesignTemplate = _interopRequireDefault(require("./DesignTemplate"));

var _handleActions;

var initialState = (0, _immutable.Map)({
  templates: (0, _immutable.Map)(),
  membershipTemplates: (0, _immutable.Map)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchSubscriptionTemplatesActionTypes.SUCCESS, function (state, action) {
  return state.updateIn(['templates'], function (templates) {
    return (0, _mergeWithCollectionOfType.default)(_DesignTemplate.default, action.payload.data.objects, templates);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchSystemTemplatesActionTypes.SUCCESS, function (state, action) {
  return state.updateIn(['templates'], function (templates) {
    return (0, _mergeWithCollectionOfType.default)(_DesignTemplate.default, action.payload.data.objects, templates);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchBlogTemplatesActionTypes.SUCCESS, function (state, action) {
  return state.updateIn(['templates'], function (templates) {
    return (0, _mergeWithCollectionOfType.default)(_DesignTemplate.default, action.payload.data.objects, templates);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchStylesheetsActionTypes.SUCCESS, function (state, action) {
  return state.updateIn(['templates'], function (templates) {
    return (0, _mergeWithCollectionOfType.default)(_DesignTemplate.default, action.payload.data.objects, templates);
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchMembershipTemplatesActionTypes.SUCCESS, function (state, action) {
  return state.updateIn(['membershipTemplates'], function (templates) {
    return (0, _mergeWithCollectionOfType.default)(_DesignTemplate.default, action.payload.data.objects, templates);
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;